export * from "./PersonDetailsList";
